import { render, staticRenderFns } from "./BindsSvgLoader.vue?vue&type=template&id=20216a54&"
import script from "./BindsSvgLoader.vue?vue&type=script&lang=js&"
export * from "./BindsSvgLoader.vue?vue&type=script&lang=js&"
import style0 from "./BindsSvgLoader.vue?vue&type=style&index=0&id=20216a54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports